import { designVariables } from "@studio3t/design-variables";
import {
  BadgeConfirmationSubtle,
  BadgeSecondarySubtle,
  Icon,
  IconSVG,
} from "@studio3t/generic-components";
import { useTheme } from "styled-components";

const BADGE = designVariables.ui.badge;

// The "zᶻ" sleep glyph for the idle badge, exported verbatim from Figma
// (node 13692-123635, Status column → idle Badge → "Leading icon" group, a
// 12×12 icon frame). The two paths are the exact Figma geometry re-based to a
// 0-origin viewBox via the translate; `fill="currentColor"` lets the badge
// theme it (originally #2E2E2E / semantic-text-body in the design).
function SleepIcon({ size, color }: { size: number; color: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ color, flexShrink: 0 }}
    >
      <g transform="translate(-813 -315)" fill="currentColor">
        <path d="M817.875 320.062C818.09 320.062 818.287 320.185 818.381 320.379C818.475 320.572 818.45 320.803 818.317 320.972L814.907 325.312H817.875C818.186 325.312 818.438 325.564 818.438 325.875C818.438 326.186 818.186 326.438 817.875 326.438H813.75C813.535 326.438 813.338 326.315 813.244 326.121C813.15 325.928 813.175 325.697 813.308 325.528L816.718 321.188H813.75C813.439 321.188 813.188 320.936 813.188 320.625C813.188 320.314 813.439 320.062 813.75 320.062H817.875Z" />
        <path d="M824.25 315.188C824.465 315.188 824.662 315.31 824.756 315.504C824.85 315.697 824.825 315.928 824.692 316.097L821.282 320.438H824.25C824.561 320.438 824.813 320.689 824.813 321C824.813 321.311 824.561 321.562 824.25 321.562H820.125C819.91 321.562 819.713 321.44 819.619 321.246C819.525 321.053 819.55 320.822 819.683 320.653L823.093 316.312H820.125C819.814 316.312 819.563 316.061 819.563 315.75C819.563 315.439 819.814 315.188 820.125 315.188H824.25Z" />
      </g>
    </svg>
  );
}

// A service is "live" when at least one pipeline using it is currently running
// (see isLive in ServicesTable) — the only live proof its connection works;
// otherwise it's "idle". Mirrors JobStatusBadge: a colored badge with a leading
// icon and a lowercase label, per Figma node 13692-123635.
export function ServiceStatusBadge({ live }: { live: boolean }) {
  const theme = useTheme();
  if (live) {
    return (
      <BadgeConfirmationSubtle>
        <IconSVG
          icon={Icon.Connection}
          size={BADGE.icon}
          colors={{ default: theme.badgeConfirmSubtleColor }}
        />
        live
      </BadgeConfirmationSubtle>
    );
  }
  return (
    <BadgeSecondarySubtle>
      <SleepIcon size={BADGE.icon} color={theme.badgeSecondarySubtleText} />
      idle
    </BadgeSecondarySubtle>
  );
}
